/**
 * Convert ISO country code to emoji flag
 * e.g., "US" -> "🇺🇸", "DE" -> "🇩🇪"
 */
export const getCountryEmoji = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return "";
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

/**
 * Format city name from snake_case to Title Case
 * e.g., "new_york" -> "New York"
 */
export const formatCityName = (cityName) => {
  if (!cityName) return "";
  return cityName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
